import React from 'react'
import s from "./Footer.module.css"
const Footer = () => {
  return (
    <div className={s.main_container}>
        <span>© 2025 Tüm Hakları Saklıdır.</span>

    </div>
  )
}

export default Footer